import escuelasService from "@/services/escuelasService";

const state = () => ({
  escuelas: [],
  escuelaSeleccionada: null,
  isLoading: false,
  error: null
});

const mutations = {
  SET_ESCUELAS(state, escuelas) {
    state.escuelas = escuelas;
  },
  SET_ESCUELA_SELECCIONADA(state, escuela) {
    state.escuelaSeleccionada = escuela;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

const actions = {
  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading);
  },
  
  async getEscuelas({ commit, state }, refresh = false) {
    try {
      if (state.escuelas.length !== 0 && !refresh) {
        console.log("Las escuelas ya están cargadas");
        return state.escuelas;
      }

      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await escuelasService.getEscuelas();

      if (response.data && response.data.data) {
        // Filtrar solo las escuelas (si es necesario)
        const escuelas = response.data.data.filter(lugar => lugar.lugar === "Escuela");
        
        // Mapear los datos para tener una estructura consistente
        const escuelasMapeadas = escuelas.map(escuela => ({
          ...escuela,
          dataText: escuela.nombre_lugar || "",
          dataValue: escuela.id_lugar || "",
        }));
        
        console.log("Escuelas cargadas:", escuelasMapeadas);
        commit("SET_ESCUELAS", escuelasMapeadas);
        return escuelasMapeadas;
      } else {
        console.error("Formato de respuesta inesperado:", response.data);
        commit('SET_ERROR', "Formato de respuesta inesperado");
        return [];
      }
    } catch (error) {
      console.error("Error al cargar las escuelas:", error);
      commit('SET_ERROR', error.message || "Error al cargar las escuelas");
      return [];
    } finally {
      commit('SET_LOADING', false);
    }
  },

  seleccionarEscuela({ commit }, escuela) {
    commit('SET_ESCUELA_SELECCIONADA', escuela);
  },

  async getEscuelaById({ commit }, id) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await escuelasService.getEscuelaById(id);

      if (response.data && response.data.data) {
        const escuela = response.data.data;
        commit('SET_ESCUELA_SELECCIONADA', escuela);
        return escuela;
      } else {
        console.error("Formato de respuesta inesperado:", response.data);
        commit('SET_ERROR', "Formato de respuesta inesperado");
        return null;
      }
    } catch (error) {
      console.error("Error al cargar la escuela:", error);
      commit('SET_ERROR', error.message || "Error al cargar la escuela");
      return null;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createEscuela({ commit, dispatch }, escuela) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await escuelasService.createEscuela(escuela);

      if (response.data && response.data.success) {
        // Recargar la lista de escuelas para incluir la nueva
        await dispatch('getEscuelas', true);
        return response.data;
      } else {
        console.error("Error al crear escuela:", response.data);
        commit('SET_ERROR', response.data.message || "Error al crear escuela");
        return null;
      }
    } catch (error) {
      console.error("Error al crear escuela:", error);
      commit('SET_ERROR', error.message || "Error al crear escuela");
      return null;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateEscuela({ commit, dispatch }, escuela) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await escuelasService.updateEscuela(escuela);

      if (response.data && response.data.success) {
        // Recargar la lista de escuelas para actualizar los datos
        await dispatch('getEscuelas', true);
        return response.data;
      } else {
        console.error("Error al actualizar escuela:", response.data);
        commit('SET_ERROR', response.data.message || "Error al actualizar escuela");
        return null;
      }
    } catch (error) {
      console.error("Error al actualizar escuela:", error);
      commit('SET_ERROR', error.message || "Error al actualizar escuela");
      return null;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteEscuela({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await escuelasService.deleteEscuela(id);

      if (response.data && response.data.success) {
        // Recargar la lista de escuelas para eliminar la escuela borrada
        await dispatch('getEscuelas', true);
        return response.data;
      } else {
        console.error("Error al eliminar escuela:", response.data);
        commit('SET_ERROR', response.data.message || "Error al eliminar escuela");
        return null;
      }
    } catch (error) {
      console.error("Error al eliminar escuela:", error);
      commit('SET_ERROR', error.message || "Error al eliminar escuela");
      return null;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  getEscuelas: (state) => state.escuelas,
  getEscuelaSeleccionada: (state) => state.escuelaSeleccionada,
  isLoading: (state) => state.isLoading,
  getError: (state) => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
